import Crud from '../views/TeamType/Crud'
import Entity from '../views/TeamType/Add'

let routes = {
    path: '/team_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/team_types/add',
            name: 'NewTeamType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Equipe',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Tipo de Equipe',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/team_types/edit/:id?',
            name: 'EditTeamType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Equipe',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Equipe',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/team_types',
            name: 'list-team-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Equipe',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Equipe',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
